import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { PmaxAdCreator } from './PmaxAdCreator';
import { SearchAdCreatorV2 } from './v2/SearchAdCreatorV2';

type CampaignMode = 'search' | 'pmax';

const MODES: Array<{
    id: CampaignMode;
    title: string;
    description: string;
}> = [
    {
        id: 'search',
        title: '搜尋廣告',
        description: '關鍵字 + Persona + 場景 + 特式化，走既有 RSA 生成流程。'
    },
    {
        id: 'pmax',
        title: 'PMAX',
        description: '進場入口 + 場景 + Landing Page + Signals，走 asset group 規劃流程。'
    }
];

function normalizeMode(value: string | null): CampaignMode {
    return value === 'pmax' ? 'pmax' : 'search';
}

export function AdCreator() {
    const [searchParams, setSearchParams] = useSearchParams();
    const mode = useMemo(() => normalizeMode(searchParams.get('mode')), [searchParams]);

    function changeMode(nextMode: CampaignMode) {
        const nextParams = new URLSearchParams(searchParams);
        nextParams.set('mode', nextMode);
        setSearchParams(nextParams, { replace: true });
    }

    return (
        <div>
            <div
                style={{
                    maxWidth: '1240px',
                    margin: '0 auto',
                    padding: '1.5rem 2rem 0'
                }}
            >
                <div
                    style={{
                        border: '1px solid var(--color-border)',
                        borderRadius: '18px',
                        background: 'var(--color-surface)',
                        padding: '1rem'
                    }}
                >
                    <div style={{ fontSize: '0.85rem', fontWeight: 800, color: 'var(--color-primary)', marginBottom: '0.5rem' }}>
                        GENERATION PATH
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: '0.75rem' }}>
                        {MODES.map((item) => (
                            <button
                                key={item.id}
                                onClick={() => changeMode(item.id)}
                                style={{
                                    textAlign: 'left',
                                    borderRadius: '14px',
                                    border: `2px solid ${mode === item.id ? 'var(--color-primary)' : 'var(--color-border)'}`,
                                    background: mode === item.id ? 'var(--color-primary-light)' : 'var(--color-bg)',
                                    padding: '1rem',
                                    cursor: 'pointer'
                                }}
                            >
                                <div style={{ fontWeight: 800, marginBottom: '0.35rem' }}>{item.title}</div>
                                <div style={{ color: 'var(--color-text-secondary)', lineHeight: 1.5 }}>{item.description}</div>
                            </button>
                        ))}
                    </div>
                </div>
            </div>

            {mode === 'search' ? <SearchAdCreatorV2 /> : <PmaxAdCreator />}
        </div>
    );
}
